// extracted by mini-css-extract-plugin
export default {"menuJoin":"c-a_er","menuJoin_show":"c-a_es"};